/**
 * Document editing modes for Collabora/WOPI
 */
export enum DocumentMode {
  Edit = 'edit',
  View = 'view'
}
